import { render, staticRenderFns } from "./DettaglioAcquisto.vue?vue&type=template&id=374ca594&"
import script from "./DettaglioAcquisto.vue?vue&type=script&lang=js&"
export * from "./DettaglioAcquisto.vue?vue&type=script&lang=js&"
import style0 from "./DettaglioAcquisto.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports